import { useState} from "react";
import { AppBar, Toolbar, Typography, IconButton, Box, Drawer, MenuItem } from "@mui/material";
import profile from '../assets/img/profile.svg'
import MenuIcon from '../assets/img/menu.svg';
import CloseIcon from '../assets/img/cross.svg';
import logo from '../assets/img/logo2.svg';
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import HomeIcon from '../assets/img/Group.svg';
import InfoIcon from '../assets/img/info.svg';
import FolderIcon from '../assets/img/folder.svg';
import PersonAddIcon from '../assets/img/user.svg';
// import LoginIcon from "@mui/icons-material/Login";

const Navigationbar = ({setCurrent,logged,profiles}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [themeIcon, setThemeIcon] = useState(false);

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  const handleMenuClick = () => {
    toggleDrawer(!drawerOpen);
  };

  const handleLogoClick = () => {
    setDrawerOpen(false);
    setCurrent(0);
  };

  document.body.style.margin = "0";
  document.body.style.padding = "0";

 const menuItems = [
  { name: "Home", icon: HomeIcon, page: 0 },
  { name: "Projects", icon: FolderIcon, page: 1 },

  ...(logged
    ? [{ name: "Register", icon: PersonAddIcon, page: 2 }]
    : []),

  { name: "About Us", icon: InfoIcon, page: 3 },

  ...(logged && profiles.role === "admin"
    ? [{ name: "Assign Mentor", icon: PersonAddIcon, page: 7 }]
    : []),

  {
    name: logged ? "Logout" : "Login",
    icon: PersonAddIcon,
    page: logged ? 5 : 4,
  },
];

  // const handleNavigation = (index) => {
  //     const lastIndex = menuItems.length - 1;
  //     if(logged && index === lastIndex){
  //       setDrawerOpen(false);
  //       setCurrent(5); // Logout
  //     } else {
  //       if(!logged && index === 2 ){
  //         setDrawerOpen(false);
  //       setCurrent(index+1);}
  //     else if(!logged && index === 3){
  //       setDrawerOpen(false);
  //       setCurrent(index+1);
  //     }else{
  //       setDrawerOpen(false);
  //       setCurrent(index);
  //     }
  //   }
  // }

 const handleNavigation = (index) => {
  const item = menuItems[index];

  setDrawerOpen(false);
  setCurrent(item.page);
};

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          height: { xs: '56px', sm: '60px' },
          width: "100%",
          backgroundColor: "#0797F3",
          boxShadow: 0,
        }}
      >
        <Toolbar
          sx={{
            px: { xs: 1.5, sm: 2, md: 3 },
            display: "flex",
            justifyContent: "space-between",
            flexGrow: 1,
          }}
        >
          <Box
            component="button"
            onClick={handleLogoClick}
            sx={{
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box component="img" src={logo} sx={{ height: { xs: 36, sm: 45 } }} alt="Logo" />
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              flexGrow: 1,
              justifyContent: 'center',
              gap: 1,
            }}
          >
            {menuItems.map((item,index) => (
                <MenuItem
                key={item.name}
                onClick = {()=>handleNavigation(index)}
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ marginLeft: "8px" }}>{item.name}</Typography>
                </MenuItem>
            ))}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: "20px" } }}>
            {logged && <IconButton sx={{ backgroundColor: "white", width: 30, height: 30, border: "1px solid lightgray", borderRadius: "25%" }}>
              <Box onClick={()=>setCurrent(6)}component="img" src={profile} sx={{height: "17px" }} alt="Logo" />
            </IconButton>}
            {/* <IconButton
              sx={{
                width: 30,
                height: 30,
                border: "1px solid lightgray",
                borderRadius: "25%",
                backgroundColor: "white",
              }}
            >
              {themeIcon ? (
                <LightModeIcon onClick={()=>setThemeIcon(false)}sx={{ fontSize: "18px", color: "white", stroke: "#0797F3", strokeWidth: 1 }} />
              ) : (
                <DarkModeIcon onClick={()=>setThemeIcon(true)}sx={{ fontSize: "20px", color: "white", stroke: "#0797F3", strokeWidth: 1 }} />
              )}
            </IconButton> */}
            <IconButton
              onClick={handleMenuClick}
              sx={{
                display: { xs: "flex", md: "none" },
                width: 30,
                height: 30,
                border: "1px solid lightgray",
                borderRadius: "25%",
              }}
            >
              {drawerOpen ? (
                <Box component="img" src={CloseIcon} sx={{height: "17px" }} alt="Logo" />
              ) : (
               <Box component="img" src={MenuIcon} sx={{height: "17px" }} alt="Logo" />
              )}
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => toggleDrawer(false)}
        ModalProps={{ BackdropProps: { invisible: true } }}
        sx={{
          "& .MuiDrawer-paper": { top: "60px", width: "250px" },
        }}
      >
        <Box sx={{ padding: 2 }}>
          {menuItems.map((item, index) => (
              <MenuItem
              key={item.name}
              onClick = {()=>handleNavigation(index)}
                sx={{
                  color: "black",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                  borderRadius: "8px",
                  padding: "10px 16px",
                }}
              >
                <Box component="img" src={item.icon} sx={{ height: "17px", marginLeft: "5px" }} alt="Logo" />
                <Typography sx={{ marginLeft: "8px" }}>{item.name}</Typography>
              </MenuItem>
          ))}
        </Box>
      </Drawer>
    </>
  );
};

export default Navigationbar;
